import type { PlateEditor } from 'platejs/react';
import { getIsEditorWithMarkdownApi } from 'src/components/ai/chat/ChatPanel/ChatEditor';
import {
  getMarkdownMentionEmails,
  getMarkdownUserMentionIds,
} from 'src/components/ai/chat/ChatPanel/ChatEditor/ChatEditorMarkdown';

export type CommentMarkdownMentions = {
  directMentionEmails: string[];
  mentionedUserIds: string[];
};

const emptyCommentMarkdownMentions: CommentMarkdownMentions = {
  directMentionEmails: [],
  mentionedUserIds: [],
};

export function getCommentMarkdownMentions(
  editor: PlateEditor | null | undefined,
  markdown: string
): CommentMarkdownMentions {
  if (!editor || !getIsEditorWithMarkdownApi(editor)) return emptyCommentMarkdownMentions;

  return {
    directMentionEmails: getMarkdownMentionEmails(editor, markdown),
    mentionedUserIds: getMarkdownUserMentionIds(editor, markdown),
  };
}
